// 存取cookies封装
import Cookies from 'js-cookie'


export function getCookies(cName) {
    return Cookies.get(cName)
}

export function setCookies(cName, value) {
    return Cookies.set(cName, value)
}

export function removeCookies(cName) {
    return Cookies.remove(cName)
} 